import {EpxWebsocketClient} from "../network";

export interface SimpleStoredClient {
  ws?: EpxWebsocketClient;
  // isAdmin?: boolean;
  ownerId?: string;
  role?: string;
  currentPath?: string;
}
